<template>
  <div>
    <secondHeader />
    <div class="comment-main">
      <sidebar />
      <main class="comment-content">
        <!-- Hero Section -->
        <section class="comment-hero">
          <div class="comment-hero-content">
            <h1 class="comment-hero-title">YouTube・Twitchコメント欄用CSS</h1>
          </div>
        </section>

        <!-- Free Comment Section -->
        <section class="comment-grid-section">
          <div class="comment-container">
            <h2 class="comment-section-title">無料コメントデザイン</h2>
            <div class="comment-grid">
              <div v-for="comment in allComments" :key="comment.id" @click="openModal(comment.component)" class="comment-card">
                <div class="comment-preview-area" :class="comment.previewBgClass">
                  
                  <!-- ふきだしコメント専用テンプレート -->
                  <div v-if="comment.id === 1" :class="comment.previewClass">
                    <div class="fukidashi-comment-area line__left font1">
                      <div class="fukidashi-comment-text">
                        <div class="fukidashi-text">こんにちは🐟</div>
                      </div>
                      <div class="fukidashi-comment-text">
                        <div class="fukidashi-text">いい天気ですね</div>
                      </div>
                    </div>
                  </div>
                  
                  <!-- ふきだし v2コメント専用テンプレート -->
                  <div v-else-if="comment.id === 2" :class="comment.previewClass">
                    <div class="v2fukidashi-comment-area line__left font1">
                      <div class="v2fukidashi-comment-text">
                        <div class="v2fukidashi-text">こんにちは🐟</div>
                      </div>
                      <div class="v2fukidashi-comment-text">
                        <div class="v2fukidashi-text">いい天気ですね</div>
                      </div>
                    </div>
                  </div>
                  
                  <!-- シンプルコメント専用テンプレート -->
                  <div v-else-if="comment.id === 3" :class="comment.previewClass">
                    <div class="simple-comment-area line__left font1">
                      <div class="simple-comment-text">
                        <div class="simple-text">こんにちは🐟</div>
                      </div>
                      <div class="simple-comment-text">
                        <div class="simple-text">いい天気ですね</div>
                      </div>
                    </div>
                  </div>
                  
                  <!-- ふちどりコメント専用テンプレート -->
                  <div v-else-if="comment.id === 4" :class="comment.previewClass">
                    <div class="shadow-comment-area line__left font1">
                      <div class="shadow-comment-text">
                        <div class="shadow-text font-shadow">こんにちは🐟</div>
                      </div>
                      <div class="shadow-comment-text">
                        <div class="shadow-text font-shadow">いい天気ですね</div>
                      </div>
                    </div>
                  </div>
                  
                  <!-- 見出しつきコメント専用テンプレート -->
                  <div v-else-if="comment.id === 5" :class="comment.previewClass">
                    <div class="midashi-comment-area line__left font1">
                      <div class="midashi-comment-text">
                        <div class="midashi-text">こんにちは🐟</div>
                      </div>
                      <div class="midashi-comment-text">
                        <div class="midashi-text">いい天気ですね</div>
                      </div>
                    </div>
                  </div>
                  
                  <!-- 横並びコメント専用テンプレート -->
                  <div v-else-if="comment.id === 6" :class="comment.previewClass">
                    <div class="slide-comment-area font1">
                      <div class="slide-comment-text">
                        <div class="slide-text">こんにちは🐟</div>
                      </div>
                      <div class="slide-comment-text">
                        <div class="slide-text">いい天気ですね</div>
                      </div>
                    </div>
                  </div>
                  
                </div>
                <div class="comment-card-content">
                  <h3 class="comment-card-title">{{ comment.name }}</h3>
                  <div class="comment-tags">
                    <span v-for="tag in comment.tags" :key="tag" class="comment-tag">{{ tag }}</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>

        <!-- モーダルの表示 -->
        <div v-if="showModal" class="modal" @click="closeModal">
          <div class="modal-content" @click.stop>
            <span class="close" @click="closeModal">&times;</span>
            <component :is="currentComponent" />
          </div>
        </div>

        <!-- Premium Comment Section -->
        <section class="comment-premium-section">
          <div class="comment-container">
            <div class="comment-premium-header">
              <h2 class="comment-section-title premium-title">プレミアムコメント欄</h2>
              <p class="comment-premium-description">より高品質で多機能なプレミアムコメントデザイン</p>
            </div>
            <div class="comment-grid">
              <div v-for="comment in premiumComments" :key="comment.id" @click="openPremiumModal(comment.carouselIndex)" class="comment-card premium-card">
                <div class="comment-premium-badge">Premium</div>
                <div class="comment-preview-area">
                  <img :src="getCarouselItem(comment.carouselIndex).thum" class="comment-preview-img" :alt="comment.name + 'デザイン'">
                </div>
                <div class="comment-card-content">
                  <h3 class="comment-card-title">{{ comment.name }}</h3>
                  <div class="comment-tags">
                    <span v-for="tag in comment.tags" :key="tag" class="comment-tag">{{ tag }}</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>

        <!-- モーダルの表示 -->
        <div v-if="showPremiumModal" class="modal" @click="closePremiumModal">
          <div class="premium-modal-content" @click.stop>
            <span class="close" @click="closePremiumModal">&times;</span>
            <div class="premium-modal-main">
              <h3>{{ carousel[currentCarouselIndex].title }}</h3>
              <p>{{ carousel[currentCarouselIndex].description }}</p>
              <img :src="carousel[currentCarouselIndex].thum" alt="Modal Image">
              <div class="btn-area">
                <a :href="carousel[currentCarouselIndex].store" target="_blank">
                    <span class="store-btn">BOOTHで購入</span>
                </a>
                <router-link :to="carousel[currentCarouselIndex].to">
                    <span class="custom-btn">カスタマイズ</span>
                </router-link>
              </div>
            </div>
          </div>
        </div>

        <!-- Ad Section -->
        <section class="comment-ad-block">
          <div class="comment-container">
            <div class="comment-ad">
              <InFeedAdsense
                  data-ad-layout-key="-fb+5w+4e-db+86"
                  data-ad-client="ca-pub-9016794589237931"
                  data-ad-slot="4898735474">
              </InFeedAdsense>
            </div>
          </div>
        </section>

        <!-- Blog Section -->
        <section class="comment-blog-area">
          <div class="comment-blog-content">
            <h2 class="comment-blog-title">使い方はブログでチェック！</h2>
            <div class="comment-blog-row">
              <div class="comment-blog-thumb">
                <img src="@/assets/article/thombnail-comment.png" alt="コメント使い方ガイド">
              </div>
              <div>
                <p class="comment-blog-desc">具体的な使い方や、おすすめのカスタマイズ方法はブログ記事で紹介しています。あわせてどうぞ！</p>
                <div class="comment-blog-btn">
                  <a href="https://www.ruri.info/obs-comment-custom/" target="_blank" rel="noopener noreferrer" class="comment-check-btn">記事をチェック</a>
                </div>
              </div>
            </div>
          </div>
        </section>

      </main>
    </div>
  </div>
</template>
<script>
import secondHeader from "../components/secondHeader.vue"
import sidebar from "../components/sidebar.vue"
import noticeBar from "../components/notice-bar.vue"

import v2fukidashi from "../components/comment/tw-frame-fukidashi.vue"
import fukidashi from "../components/comment/fukidashiComment.vue"
import simpleComment from '../components/comment/simpleComment.vue'
import shadowTxtComment from '../components/comment/shadowTxtComment.vue'
import midashi1Comment from '../components/comment/midashi1Comment.vue'
import slideComment from '../components/comment/slideComment.vue'

export default{
    components:{
      sidebar,
      noticeBar,
      v2fukidashi,
      fukidashi,
      secondHeader,
      simpleComment,
      shadowTxtComment,
      midashi1Comment,
      slideComment,
    },
    data(){
      return{
        isProduction: process.env.NODE_ENV === "production",
        showModal: false,
        showPremiumModal: false,
        currentComponent: null,
        currentCarouselIndex: null,
        allComments: [
          {
            id: 1,
            name: 'ふきだし',
            component: 'fukidashi',
            type: 'live',
            isPremium: false,
            tags: ['基本', '左右切替', 'フォント変更', '色変更'],
            previewClass: 'fukidashi-live-preview',
            previewBgClass: 'fukidashi-preview-bg'
          },
          {
            id: 2,
            name: 'ふきだし v2',
            component: 'v2fukidashi',
            type: 'live',
            isPremium: false,
            tags: ['フォント変更', '色変更'],
            previewClass: 'v2fukidashi-live-preview',
            previewBgClass: 'v2fukidashi-preview-bg'
          },
          {
            id: 3,
            name: 'シンプル',
            component: 'simpleComment',
            type: 'live',
            isPremium: false,
            tags: ['ミニマル', 'フォント変更', '色変更'],
            previewClass: 'simple-live-preview',
            previewBgClass: 'simple-preview-bg'
          },
          {
            id: 4,
            name: 'ふちどり',
            component: 'shadowTxtComment',
            type: 'live',
            isPremium: false,
            tags: ['フォント変更', '色変更'],
            previewClass: 'shadow-live-preview',
            previewBgClass: 'shadow-preview-bg'
          },
          {
            id: 5,
            name: '見出しつき',
            component: 'midashi1Comment',
            type: 'live',
            isPremium: false,
            tags: ['フォント変更', '色変更'],
            previewClass: 'midashi-live-preview',
            previewBgClass: 'midashi-preview-bg'
          },
          {
            id: 6,
            name: '横並び',
            component: 'slideComment',
            type: 'live',
            isPremium: false,
            tags: ['横スクロール', 'フォント変更', '色変更'],
            previewClass: 'slide-live-preview',
            previewBgClass: 'slide-preview-bg'
          }
        ],
        premiumComments: [
          {
            id: 14,
            name: 'アイコンふきだし',
            carouselIndex: 14,
            tags: ['アニメーション','アイコン変更', '色変更']
          },
          {
            id: 12,
            name: '夜空',
            carouselIndex: 12,
            tags: ['月・星', 'アニメーション']
          },
          {
            id: 6,
            name: '肉球 v2',
            carouselIndex: 6,
            tags: ['アニメーション', '色変更']
          },
          {
            id: 7,
            name: 'ハート',
            carouselIndex: 7,
            tags: ['アニメーション', '色変更']
          },
          {
            id: 8,
            name: 'プレミアムふきだし',
            carouselIndex: 8,
            tags: ['アニメーション', '色変更']
          },
          {
            id: 10,
            name: '半透明',
            carouselIndex: 10,
            tags: ['アニメーション', '色変更']
          },
          {
            id: 13,
            name: '半透明 v2',
            carouselIndex: 13,
            tags: ['アニメーション', '色変更']
          },
          {
            id: 9,
            name: 'グリッチ',
            carouselIndex: 9,
            tags: ['アニメーション', '色変更', 'フォント変更']
          },
          {
            id: 11,
            name: '肉球',
            carouselIndex: 11,
            tags: ['アニメーション', '色変更', 'フォント変更']
          }
        ],
        carousel:[
          {
            index: 6,
            src: require("@/assets/carousel/nikukyu-comment.png"),
            thum: require("@/assets/thumbnail/premium-cat2.png"),
            store:"https://takatsukisyou.booth.pm/items/5181357",
            title: "肉球コメント v2",
            to: "/premium-nyan2",
            description:"OBSで使えるコメント用のカスタムCSS。かわいい肉球とアニメーションが特徴です。",
          },
          {
            index: 7,
            src: require("@/assets/carousel/heart-comment.png"),
            thum: require("@/assets/thumbnail/premium-heart.png"),
            store:"https://takatsukisyou.booth.pm/items/5181364",
            title: "ハートコメント",
            to: "/premium-heart",
            description:"OBSで使えるコメント用のカスタムCSS。ハートがアクセントのデザインです",
          },
          {
            index: 8,
            src: require("@/assets/carousel/fukidashi-comment.png"),
            thum: require("@/assets/thumbnail/premium-fukidashi.png"),
            to: "/premium-fukidashi",
            store:"https://takatsukisyou.booth.pm/items/4863903",
            title: "プレミアムふきだしコメント",
            description:"OBSで使えるコメント用のカスタムCSS。無料版より作りこんだふきだしです。無料版との違いは、「改行時などのレイアウト崩れなし」「きれいなしっぽ」「アニメーション付き」「各サイトの最新の仕様に対応」です。",
          },
          {
            index: 9,
            src: require("@/assets/carousel/glitch-comment.png"),
            thum: require("@/assets/thumbnail/premium-glitch.png"),
            to: "/premium-nyan",
            store:"https://takatsukisyou.booth.pm/items/4919770",
            title: "プレミアムグリッチコメント",
            description:"OBSで使えるコメント用のカスタムCSS。グリッチっぽいアニメーションが特徴。小さなスペースにも使えるシンプルなデザインです。",
          },
          {
            index: 10,
            src: require("@/assets/carousel/toumei-comment.png"),
            thum: require("@/assets/thumbnail/premium-transparent1.png"),
            to: "/premium-transparent1",
            store:"https://takatsukisyou.booth.pm/items/5119454",
            title: "プレミアム半透明コメント",
            description:"OBSで使えるコメント用のカスタムCSS。半透明なふきだしでゲーム画面など、背景と合わせるのに向いています。YouTube・Twitch用とわんコメのテンプレートもあります。",
          },
          {
            index: 11,
            src: require("@/assets/carousel/nikukyu-2-comment.png"),
            thum: require("@/assets/thumbnail/premium-cat.png"),
            to: "/premium-nyan",
            store:"https://takatsukisyou.booth.pm/items/4856981",
            title: "肉球コメント",
            description:"OBSで使えるコメント用のカスタムCSS。かわいい肉球とアニメーションが特徴です。カラーは3種類！",
          },
          {
            index: 12,
            src: require("@/assets/carousel/moon-comment.png"),
            thum: require("@/assets/thumbnail/premium-moon.png"),
            store:"https://takatsukisyou.booth.pm/items/5855015",
            title: "夜空コメント",
            description:"OBSで使えるコメント用のカスタムCSS。月と星がアクセントのデザインです。",
          },
          {
            index: 13,
            thum: require("@/assets/thumbnail/premium-transparent.png"),
            to: "/premium-transparent",
            store:"https://takatsukisyou.booth.pm/items/6224976",
            title: "半透明 v2",
            description:"OBSで使えるコメント用のカスタムCSS。半透明でゲーム画面にも合わせやすく、色も自由に変更できます。",
          },
          {
            index: 14,
            thum: require("@/assets/thumbnail/premium-iconfukidashi.png"),
            to: "/premium-iconfukidashi",
            store:"https://takatsukisyou.booth.pm/items/7268629",
            title: "アイコンふきだし",
            description:"OBSで使えるコメント用のカスタムCSS。アイコンをふきだしにします。",
          }
        ]
      }
    },
    methods: {
      openModal(componentName) {
        this.currentComponent = componentName;
        this.showModal = true;
      },
      openPremiumModal(index) {
        const carouselItem = this.carousel.find(item => item.index === index);
        if (carouselItem) {
          this.currentCarouselIndex = this.carousel.indexOf(carouselItem);
          this.showPremiumModal = true;
        }
      },
      closeModal() {
        this.showModal = false;
      },
      closePremiumModal() {
        this.showPremiumModal = false;
      },
      getCarouselItem(index) {
        return this.carousel.find(item => item.index === index) || {};
      }
    }
}
</script>
<style scoped>
@import url('https://fonts.googleapis.com/css2?family=Zen+Kaku+Gothic+Antique&display=swap');

/* Reset & Base */
* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}

/* Layout */
.comment-main {
  min-height: 100vh;
  display: flex;
}

.comment-content {
  flex: 1;
  background: #fafafa;
  padding: 0 16px;
  overflow-x: hidden;
}

/* Container */
.comment-container {
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 24px;
}

/* Hero Section */
.comment-hero {
  background: white;
  padding: 48px 0;
}

.comment-hero-content {
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 24px;
  text-align: center;
}

.comment-hero-title {
  font-size: 2.25rem;
  font-weight: 700;
  color: #0f172a;
  letter-spacing: -0.025em;
}

/* Comment Grid Section */
.comment-grid-section {
  background: white;
  padding: 48px 0;
}

.comment-premium-section {
  background: #f8fafc;
  padding: 48px 0;
  border-top: 1px solid #e2e8f0;
}

.comment-premium-header {
  text-align: center;
  margin-bottom: 48px;
}

.comment-section-title {
  font-size: 1.875rem;
  font-weight: 600;
  color: #0f172a;
  margin-bottom: 12px;
  letter-spacing: -0.025em;
}

.premium-title {
  background: linear-gradient(135deg, #f59e0b 0%, #d97706 100%);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
}

.comment-premium-description {
  font-size: 1rem;
  color: #64748b;
  font-weight: 400;
}

.comment-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(280px, 1fr));
  gap: 24px;
  margin-top: 32px;
}

.comment-card {
  background: white;
  border: 1px solid #e2e8f0;
  border-radius: 16px;
  padding: 20px;
  position: relative;
  transition: all 0.2s ease;
  cursor: pointer;
  overflow: hidden;
}

.comment-card:hover {
  border-color: #cbd5e1;
  box-shadow: 0 8px 25px rgba(0, 0, 0, 0.08);
  transform: translateY(-2px);
}

.comment-premium-badge {
  position: absolute;
  top: 12px;
  right: 12px;
  background: linear-gradient(135deg, #f59e0b 0%, #d97706 100%);
  color: white;
  font-size: 0.75rem;
  font-weight: 600;
  padding: 4px 10px;
  border-radius: 6px;
  letter-spacing: 0.5px;
  z-index: 2;
}

.comment-preview-area {
  height: 180px;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 16px;
  border-radius: 12px;
  overflow: hidden;
  background: #f8fafc;
}

.comment-preview-img {
  max-width: 100%;
  max-height: 100%;
  object-fit: contain;
  border-radius: 8px;
}

.comment-card-content {
  text-align: left;
}

.comment-card-title {
  font-size: 1.125rem;
  font-weight: 600;
  color: #0f172a;
  margin-bottom: 12px;
  line-height: 1.4;
}

.comment-tags {
  display: flex;
  flex-wrap: wrap;
  gap: 6px;
}

.comment-tag {
  font-size: 0.75rem;
  font-weight: 500;
  color: #64748b;
  background: #f1f5f9;
  border: 1px solid #e2e8f0;
  padding: 4px 8px;
  border-radius: 6px;
  letter-spacing: 0.25px;
}


/* Modal */
.modal {
  display: block;
  position: fixed;
  z-index: 1000;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  overflow: auto;
  background-color: rgba(0, 0, 0, 0.7);
  text-align: left;
}

.modal-content {
  background-color: #fefefe;
  margin: 2vh auto;
  padding: 32px;
  border: none;
  border-radius: 16px;
  width: 90%;
  max-width: 1000px;
  min-height: 85vh;
  box-shadow: 0 25px 50px rgba(0, 0, 0, 0.25);
}

.close {
  color: #64748b;
  float: right;
  font-size: 32px;
  font-weight: bold;
  line-height: 1;
  transition: color 0.2s ease;
}

.close:hover,
.close:focus {
  color: #0f172a;
  text-decoration: none;
  cursor: pointer;
}

/* Ad Section */
.comment-ad-block {
  background: #f8fafc;
  padding: 48px 0;
  text-align: center;
}

.comment-ad {
  max-width: 70%;
  margin: 0 auto;
  display: block;
}

/* Blog Area */
.comment-blog-area {
  background: white;
  padding: 48px 0;
  border-top: 1px solid #e2e8f0;
}

.comment-blog-content {
  max-width: 800px;
  margin: 0 auto;
  padding: 0 24px;
}

.comment-blog-title {
  font-size: 1.75rem;
  font-weight: 600;
  color: #0f172a;
  text-align: center;
  margin-bottom: 32px;
  letter-spacing: -0.025em;
}

.comment-blog-row {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 32px;
  align-items: center;
}

.comment-blog-thumb img {
  width: 100%;
  border-radius: 12px;
  box-shadow: 0 8px 25px rgba(0, 0, 0, 0.1);
}

.comment-blog-desc {
  font-size: 1rem;
  line-height: 1.7;
  color: #64748b;
  margin-bottom: 24px;
}

.comment-blog-btn .comment-check-btn {
  display: inline-block;
  background: #0f172a;
  color: white;
  text-decoration: none;
  padding: 12px 24px;
  border-radius: 8px;
  font-weight: 500;
  font-size: 0.875rem;
  transition: all 0.2s ease;
}

.comment-blog-btn .comment-check-btn:hover {
  background: #1e293b;
  transform: translateY(-1px);
  box-shadow: 0 8px 25px rgba(0, 0, 0, 0.15);
}

/* Premium Modal */
.premium-modal-content {
  background-color: #fefefe;
  margin: 2vh auto;
  padding: 32px;
  border: none;
  border-radius: 16px;
  width: 90%;
  max-width: 1000px;
  min-height: 85vh;
  text-align: center;
  box-shadow: 0 25px 50px rgba(0, 0, 0, 0.25);
}

.premium-modal-main {
  padding-top: 5%;
}

.premium-modal-main h3 {
  font-size: 1.75rem;
  font-weight: 600;
  color: #0f172a;
  margin-bottom: 16px;
}

.premium-modal-content img {
  max-width: 400px;
  margin: 24px auto;
  border-radius: 12px;
  box-shadow: 0 8px 25px rgba(0, 0, 0, 0.1);
}

.premium-modal-content a {
  text-decoration: none;
}

.store-btn {
  display: inline-block;
  color: #fff;
  background: linear-gradient(135deg, #eb6100 0%, #f56500 100%);
  padding: 12px 24px;
  border-radius: 8px;
  font-weight: 600;
  font-size: 0.875rem;
  letter-spacing: 0.5px;
  margin: 8px 6px;
  transition: all 0.2s ease;
  box-shadow: 0 4px 12px rgba(235, 97, 0, 0.3);
}

.store-btn:hover {
  transform: translateY(-2px);
  box-shadow: 0 8px 25px rgba(235, 97, 0, 0.4);
}

.custom-btn {
  display: inline-block;
  color: #fff;
  background: linear-gradient(135deg, #0f172a 0%, #1e293b 100%);
  padding: 12px 24px;
  border-radius: 8px;
  font-weight: 600;
  font-size: 0.875rem;
  letter-spacing: 0.5px;
  margin: 8px 6px;
  transition: all 0.2s ease;
  box-shadow: 0 4px 12px rgba(15, 23, 42, 0.3);
}

.custom-btn:hover {
  transform: translateY(-2px);
  box-shadow: 0 8px 25px rgba(15, 23, 42, 0.4);
}

/* ふきだしコメントのライブプレビュー */
.fukidashi-preview-bg {
  background: linear-gradient(135deg, #f0f4f8 0%, #e2e8f0 100%);
}

.fukidashi-live-preview {
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 16px;
  box-sizing: border-box;
}

.fukidashi-comment-area {
  display: block;
  white-space: nowrap;
  padding: 8px 12px;
  border-radius: 8px;
  max-width: 240px;
}

.fukidashi-comment-area.line__left {
  background-color: #cbd5e1;
}

.fukidashi-comment-text {
  margin: 3px 0;
}

.fukidashi-text {
  margin: 3px 10px;
  padding: 6px 10px;
  position: relative;
  display: inline-block;
  border-radius: 15px;
  background-color: #ffffff;
  color: #000000;
  font-size: 12px;
  line-height: 1.3;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
}

.fukidashi-text::after {
  content: '';
  position: absolute;
  display: block;
  width: 0;
  height: 0;
  left: -7px;
  top: 8px;
  border-right: 14px solid #ffffff;
  border-top: 7px solid transparent;
  border-bottom: 7px solid transparent;
}

.font1 {
  font-family: 'Zen Kaku Gothic Antique', sans-serif;
}

/* ふきだし v2コメントのライブプレビュー */
.v2fukidashi-preview-bg {
  background: linear-gradient(135deg, #f1f5f9 0%, #e2e8f0 100%);
}

.v2fukidashi-live-preview {
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 16px;
  box-sizing: border-box;
}

.v2fukidashi-comment-area {
  display: block;
  white-space: nowrap;
  max-width: 240px;
}

.v2fukidashi-comment-text {
  margin: 3px 0;
}

.v2fukidashi-text {
  font-weight: bold;
  line-height: 1.5;
  letter-spacing: 0.1em;
  margin: 3px 10px;
  padding: 8px 16px;
  position: relative;
  display: inline-block;
  color: #571512;
  border-radius: 12px;
  background: #f0c8a4;
  outline: 2px dashed #571512;
  outline-offset: -6px;
  border: 2px solid #571512;
  font-size: 11px;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
}

.v2fukidashi-text::after,
.v2fukidashi-text::before {
  right: 100%;
  top: 50%;
  border: solid transparent;
  content: "";
  height: 0;
  width: 0;
  position: absolute;
}

.v2fukidashi-text::after {
  border-right-color: #f0c8a4;
  border-width: 5px;
  margin-top: -5px;
}

.v2fukidashi-text::before {
  border-right-color: #571512;
  border-width: 8px;
  margin-top: -8px;
}

/* シンプルコメントのライブプレビュー */
.simple-preview-bg {
  background: linear-gradient(135deg, #f1f5f9 0%, #e2e8f0 100%);
}

.simple-live-preview {
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 16px;
  box-sizing: border-box;
}

.simple-comment-area {
  display: block;
  white-space: nowrap;
  max-width: 240px;
}

.simple-comment-text {
  margin: 3px 0;
}

.simple-text {
  margin: 3px 10px;
  padding: 6px 10px;
  position: relative;
  border-radius: 15px;
  color: #1e77b0;
  font-size: 12px;
  line-height: 1.3;
}

/* ふちどりコメントのライブプレビュー */
.shadow-preview-bg {
  background: linear-gradient(135deg, #f1f5f9 0%, #e2e8f0 100%);
}

.shadow-live-preview {
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 16px;
  box-sizing: border-box;
}

.shadow-comment-area {
  display: block;
  white-space: nowrap;
  max-width: 240px;
}

.shadow-comment-text {
  margin: 3px 0;
}

.shadow-text {
  margin: 8px 10px;
  padding: 0px 10px;
  position: relative;
  color: white;
  letter-spacing: 1px;
  font-size: 12px;
  line-height: 1.4;
}

.shadow-text::before {
  position: absolute;
  top: 15%;
  left: 0;
  width: 4px;
  height: 70%;
  content: '';
  opacity: 0.6;
  border-radius: 2px;
  background: #EC2F57;
  box-sizing: inherit;
}

.font-shadow {
  text-shadow:
    #EC2F57 1px 0px, #EC2F57 -1px 0px,
    #EC2F57 0px -1px, #EC2F57 0px 1px,
    #EC2F57 1px 1px, #EC2F57 -1px 1px,
    #EC2F57 1px -1px, #EC2F57 -1px -1px,
    #EC2F57 1px 1px, #EC2F57 -1px 1px,
    #EC2F57 1px -1px, #EC2F57 -1px -1px,
    #EC2F57 1px 1px, #EC2F57 -1px 1px,
    #EC2F57 1px -1px, #EC2F57 -1px -1px;
}

/* 見出し付きコメントのライブプレビュー */
.midashi-preview-bg {
  background: linear-gradient(135deg, #f1f5f9 0%, #e2e8f0 100%);
}

.midashi-live-preview {
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 16px;
  box-sizing: border-box;
}

.midashi-comment-area {
  display: block;
  white-space: nowrap;
  max-width: 240px;
}

.midashi-comment-text {
  margin: 3px 0;
}

.midashi-text {
  margin: 8px 10px;
  padding: 0px 10px;
  position: relative;
  color: #890CCD;
  letter-spacing: 1px;
  font-size: 12px;
  line-height: 1.4;
}

.midashi-text::before {
  position: absolute;
  top: 18%;
  left: 0;
  width: 4px;
  height: 70%;
  content: '';
  opacity: 0.6;
  border-radius: 2px;
  background: #890CCD;
  box-sizing: inherit;
}

/* 横並びコメントのライブプレビュー */
.slide-preview-bg {
  background: linear-gradient(135deg, #f1f5f9 0%, #e2e8f0 100%);
}

.slide-live-preview {
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 16px;
  box-sizing: border-box;
}

.slide-comment-area {
  display: flex;
  white-space: nowrap;
  gap: 8px;
}

.slide-comment-text {
  margin: 0;
}

.slide-text {
  padding: 6px 8px;
  letter-spacing: 1px;
  font-size: 11px;
  color: #000000;
  text-shadow: 1px 1px 1px rgba(255, 255, 255, 0.4);
}

/* Responsive */
@media (max-width: 1024px) {
  .comment-grid {
    grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
    gap: 20px;
  }
  
  .comment-container {
    padding: 0 20px;
  }
}

@media (max-width: 768px) {
  .comment-hero {
    padding: 32px 0;
  }
  
  .comment-hero-title {
    font-size: 1.875rem;
  }
  
  .comment-grid-section, .comment-premium-section {
    padding: 32px 0;
  }
  
  .comment-grid {
    grid-template-columns: repeat(auto-fit, minmax(240px, 1fr));
    gap: 16px;
  }
  
  .comment-card {
    padding: 16px;
  }
  
  .comment-preview-area {
    height: 160px;
    margin-bottom: 12px;
  }
  
  .comment-container {
    padding: 0 16px;
  }
  
  .comment-content {
    padding: 0 8px;
  }
  
  .comment-blog-row {
    grid-template-columns: 1fr;
    gap: 24px;
  }
  
  .modal-content, .premium-modal-content {
    width: 95%;
    padding: 24px;
    margin: 5vh auto;
  }
}

@media (max-width: 480px) {
  .comment-hero-title {
    font-size: 1.5rem;
  }
  
  .comment-grid {
    grid-template-columns: 1fr;
    gap: 12px;
  }
  
  .comment-preview-area {
    height: 140px;
  }
  
  .comment-container {
    padding: 0 12px;
  }
  
  .comment-content {
    padding: 0 4px;
  }
  
  .comment-card-title {
    font-size: 1rem;
  }
  
  .modal-content, .premium-modal-content {
    width: 98%;
    padding: 16px;
    margin: 2vh auto;
    min-height: 90vh;
  }
}
</style>